import { useAppStore } from '../stores/appStore'

const Sidebar = ({ onPageChange, currentPath }) => {
  const { sidebarOpen, closeSidebar } = useAppStore()

  const menuItems = [
    {
      path: '/account-management',
      icon: '👤',
      label: '账号管理',
      enabled: true
    },
    {
      path: '/group-management',
      icon: '📁',
      label: '组管理',
      enabled: true
    },
    {
      path: '/daily-tasks',
      icon: '📋',
      label: '日常任务',
      enabled: true
    },
    {
      path: '/cultivate-general',
      icon: '⚔️',
      label: '武将培养',
      enabled: true
    },
    {
      path: '/changelog',
      icon: '📝',
      label: '更新日志',
      enabled: true
    }
  ]

  const handleMenuClick = (item) => {
    if (!item.enabled) return
    onPageChange(item.path)
  }

  return (
    <div className={`sidebar ${sidebarOpen ? 'show' : ''}`}>
      <div className="sidebar-header">
        <h4>汉将无双辅助</h4>
        <button className="close-sidebar" onClick={closeSidebar}>
          &times;
        </button>
      </div>

      <ul className="sidebar-nav">
        {menuItems.map((item) => (
          <li key={item.path} className="sidebar-nav-item">
            <a
              href="#"
              className={`sidebar-nav-link ${currentPath === item.path ? 'active' : ''
                }`}
              style={{
                opacity: item.enabled ? 1 : 0.5,
                pointerEvents: item.enabled ? 'auto' : 'none'
              }}
              onClick={(e) => {
                e.preventDefault()
                handleMenuClick(item)
              }}
            >
              <i>{item.icon}</i>
              {item.label}
              {item.comingSoon && (
                <small style={{ marginLeft: 'auto', opacity: 0.7 }}>
                  (即将推出)
                </small>
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Sidebar
